import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { downloadReportData, getReportData } from 'api/requests/reporting-requests';
import { ReportType } from 'constants/ReportType';
import {
  REPORTING__GET_DATA,
  REPORTING__GET_DATA_ERROR,
  REPORTING__GET_DATA_PAYLOAD,
  REPORTING__GENERAL_LOADING,
  REPORTING__CLEAR_REPORTS,
  REPORTING__EXPORT_REPORT,
} from 'store/constants';
import ReportingFilter from 'types/reporting/ReportingFilter';
import ReportingResult from 'types/reporting/ReportingResult';

export const setReportsRequestsLoadingAction = createAction<boolean>(REPORTING__GENERAL_LOADING);

export const getReportsErrorAction = createAction<boolean>(REPORTING__GET_DATA_ERROR);
export const getReportsPayloadAction = createAction<ReportingResult>(REPORTING__GET_DATA_PAYLOAD);
export const clearReportsAction = createAction<void>(REPORTING__CLEAR_REPORTS);

export const getReportsAction = createAsyncThunk(REPORTING__GET_DATA, async (filters: ReportingFilter, thunkApi) => {
  thunkApi.dispatch(setReportsRequestsLoadingAction(true));
  thunkApi.dispatch(getReportsErrorAction(false));
  try {
    const reports = await getReportData(filters);
    thunkApi.dispatch(getReportsPayloadAction(reports));
  } catch (error) {
    thunkApi.dispatch(getReportsErrorAction(true));
  }
  thunkApi.dispatch(setReportsRequestsLoadingAction(false));
});

export const downloadReportAction = createAsyncThunk(
  REPORTING__EXPORT_REPORT,
  async (props: { reportType: ReportType; filters: ReportingFilter; ids: string[] }, thunkApi) => {
    const { reportType, filters, ids } = props;
    thunkApi.dispatch(setReportsRequestsLoadingAction(true));
    try {
      const response = await downloadReportData(filters, ids);

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      const date = new Date().toISOString().split('T')[0];
      link.href = url;
      switch (reportType) {
        case ReportType.FTE_CHECK:
          link.setAttribute('download', `FTECheck_${date}.xlsx`);
          break;
        case ReportType.STATISTICS_PER_COST_CENTER:
          link.setAttribute('download', `StatisticsPerCostCenter_${date}.xlsx`);
          break;
        default:
      }
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error(error);
    } finally {
      thunkApi.dispatch(setReportsRequestsLoadingAction(false));
    }
  },
);
